import { createContext } from "react";
export default createContext({
  transformURL: function transformURL(url) {
    return url;
  }
});